import { useEffect } from "react"
import { withTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { SeoTags } from "../../components"
import { PartnersListComponent } from "../../components/info/PartnersComponent/PartnersInfoComponent/PartnersListComponent"
import { setSearchBlockCompact, setShowSearch } from "../../store/appConfigsSlice"

const SuppliersPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowSearch(true));
    dispatch(setSearchBlockCompact(true));
  }, [dispatch]);

  return (
    <>
      <SeoTags pageKey="partnersPage" />
      <PartnersListComponent />
    </>
  );
};

export default withTranslation()(SuppliersPage);
